module.exports = __webpack_public_path__ + "static/img/point_text1.b2bf290.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/point_text1.png
// module id = JGA7
// module chunks = 1